import 'css-chunksrc/client/pages/projectPage/timeSheetPage/loader/allocation/recordList/resourceTimeOverview/styles.scss';export default {
  "resourceTimeOverview": "_resourceTimeOverview_19b2g_1",
  "cell": "_cell_19b2g_8",
  "text": "_text_19b2g_21",
  "resource": "_resource_19b2g_1",
  "list": "_list_19b2g_30",
  "task": "_task_19b2g_34"
};